<div class="ui grid">
  <div *ngIf="totalAverageDto" style="margin-top: 30px;" class="centered column two ui wide">
    <div class="ui centered grid">
      <div class="ui statistic">
        <div class="value">{{totalAverageDto?.messageGuest}}</div>
        <div class="label">Guest Messages</div>
      </div>

      <div class="ui statistic">
        <div class="value">{{totalAverageDto?.messageStaff}}</div>
        <div class="label">Staff Messages</div>
      </div>

      <div class="ui statistic">
        <div class="value">{{totalAverageDto?.average}}</div>
        <div class="label">Minutes</div>
      </div>
    </div>
  </div>
  <div class="fourteen wide column">
    <chart #chart style="height: 350px;"
           [type]="chartData.type"
           [datasets]="chartData.data.datasets"
           [labels]="chartData.data.labels"
           [options]="chartData.options">
    </chart>
    <chart #chartByHour style="height: 350px;"
           [type]="chartDataByHour.type"
           [datasets]="chartDataByHour.data.datasets"
           [labels]="chartDataByHour.data.labels"
           [options]="chartDataByHour.options">
    </chart>
  </div>
</div>
